module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "gallery"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(!_vm.isTop) ? _c('div', {
    staticClass: "col-md-12 col-sm-6"
  }, [_c('h3', {
    staticStyle: {
      "color": "#58585a"
    }
  }, [_vm._v("Printer Counters Dashboard Screens")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeGallery), function(img) {
    return _c('div', {
      staticClass: "col-md-6 col-sm-6",
      staticStyle: {
        "padding-bottom": "50px"
      }
    }, [_c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "media-body wow fadeIn",
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('h4', [_vm._v(_vm._s(img.title))]), _vm._v(" "), _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": img.src,
        "alt": "Printer Counters"
      }
    })])])])
  })], 2), _vm._v(" "), _c('tryBtn')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-95a64ea6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/gallery.vue
// module id = 738
// module chunks = 0